import {
  FaDatabase,
  FaRobot,
  FaLightbulb,
  FaPenNib,
  FaChartBar,
  FaArrowRight,
  FaCode,
} from 'react-icons/fa';

const servicesLeft = [
  { icon: <FaDatabase className="text-orange-500 text-[60px] mb-2" />, title: 'Data Management' },
  { icon: <FaRobot className="text-orange-500 text-[60px] mb-2" />, title: 'AI & ML' },
  { icon: <FaChartBar className="text-orange-500 text-[60px] mb-2" />, title: 'Data Visualization' },
  { icon: <FaArrowRight className="text-orange-500 text-[60px] mb-2" />, title: 'And More...' },
];

const servicesRight = [
  { icon: <FaLightbulb className="text-orange-500 text-[60px] mb-2" />, title: 'Product Ideation' },
  { icon: <FaPenNib className="text-orange-500 text-[60px] mb-2" />, title: 'UI/UX Design' },
  { icon: <FaCode className="text-orange-500 text-[60px] mb-2" />, title: 'Product Development' },
  { icon: <FaArrowRight className="text-orange-500 text-[60px] mb-2" />, title: 'And More...' },
];

export default function ServicesGrid() {
  return (
    <section className="w-full mx-auto py-16 px-4" id="services">
      <div className="flex flex-col md:flex-row items-center justify-center gap-8">
        {/* Left Column */}
        <div className="grid grid-cols-2 gap-y-10 gap-x-4 md:pr-6">
          {servicesLeft.map((service, index) => (
            <div
              key={index}
              className="text-center flex items-center justify-center flex-col w-full md:w-[20vw]"
            >
              {service.icon}
              <p className="text-xl md:text-2xl font-[400] text-gray-700">{service.title}</p>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="hidden md:block w-1 h-[150px] bg-[#212121]" />

        {/* Right Column */}
        <div className="grid grid-cols-2 gap-y-10 gap-x-4 md:pl-6">
          {servicesRight.map((service, index) => (
            <div
              key={index}
              className="text-center flex items-center justify-center flex-col w-full md:w-[20vw]"
            >
              {service.icon}
              <p className="text-xl md:text-2xl font-[400] text-gray-700">{service.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
